import React from 'react';
import { useTranslation } from 'react-i18next';
import { getTranslationErrorHandling } from 'Hooks/query-hooks/helper';
import useReduxModal from 'Hooks/reduxHelperHooks/useReduxModal';
import { useHistory } from 'react-router-dom';

const useSingleList404Modal = () => {
    const { t } = useTranslation();
    const errorStringKey = getTranslationErrorHandling(t);
    const { addTechnicalErrorModal } = useReduxModal();
    const history = useHistory();

    const listNotFound = () => {
        addTechnicalErrorModal('', errorStringKey('listDeleted'), () => {}, {
            status: 'warning',
            onClose: () => {
                history.push('/list-management');
            },
            content: (
                <>
                    {errorStringKey('listCantBeModified')}
                    <br />
                    <br />
                    {errorStringKey('listNavigateBack')}
                </>
            )
        });
    };

    return { listNotFound };
};

export default useSingleList404Modal;
